<template>
    <!--:key="$route.path" makes the navbar recreate (close) itself on every navigation, which it did by default before version 2.9 -->
    <b-navbar toggleable="md" type="light" fixed='top' :key="$route.path" class='nav-bar navbar-expand-sm'>
        <b-navbar-brand style='cursor:pointer' @click='navigateTo("Home")'>
            <span class="drawdown-blue logo-typeface">Handweaving</span><span class="drawdown-red logo-typeface">.net</span>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse is-nav id='nav-collapse'>
            <b-navbar-nav>
                <b-nav-item class="ml-sm-2" @click='navigateTo("Drafts")'>Drafts</b-nav-item>
                <b-nav-item class="ml-sm-2" @click='navigateTo("Docs")'>Docs</b-nav-item>
                <b-nav-item-dropdown class="ml-sm-2" id='store-menu' text="Store">
                    <b-nav-item target='_blank' href='http://store.handweaving.net'>Browse Our Store</b-nav-item>
                    <b-nav-item @click='navigateTo("DigitalDownloads")'>Downloads</b-nav-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown class="ml-sm-2" text="About">
                    <b-nav-item @click='navigateTo("About")'>About Us</b-nav-item>
                    <b-nav-item @click='navigateTo("Acknowledgements")'>Acknowledgements</b-nav-item>
                    <b-nav-item @click='navigateTo("Contact")'>Contact Us</b-nav-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown class="ml-sm-2" text="Help">
                    <b-nav-item @click='navigateTo("Help")'>Site Help / FAQ</b-nav-item>
                    <b-nav-item target='_blank' href='https://www.youtube.com/channel/UCbQhW5AwY9hYsXAXbyg3qmQ'>Video Tutorials</b-nav-item>
                    <b-nav-item @click='navigateTo("WeavingSoftware")'>Weaving Software</b-nav-item>
                    <b-nav-item @click='navigateTo("Contact")'>Contact Us</b-nav-item>
                    <b-nav-item @click='navigateTo("Updates")'>Site Updates</b-nav-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown class="ml-sm-2" text="Account">
                    <b-nav-item v-if='this.isAuthenticated' @click='navigateTo("Account")'>My&nbsp;Account</b-nav-item>
                    <b-nav-item v-if='this.isAuthenticated' @click='navigateTo("Subscription")'>My&nbsp;Subscription</b-nav-item>
                    <b-nav-item v-if='this.isAuthenticated' @click='navigateTo("Settings")'>My&nbsp;Settings</b-nav-item>                
                    <b-nav-item v-if='!this.isAuthenticated' @click='navigateTo("Login")'>Sign&nbsp;In</b-nav-item>
                    <b-nav-item v-if='!this.isAuthenticated' @click='navigateTo("Account")'>Register</b-nav-item>
                    <b-nav-item @click='navigateToClipboard()'>My&nbsp;Clipboard</b-nav-item>
                    <b-nav-item @click='navigateToBoards()'>My&nbsp;Draft&nbsp;Boards</b-nav-item>
                    <b-nav-item @click='navigateToTagCloud("mytags")'>My&nbsp;Draft&nbsp;Tags</b-nav-item>
                    <b-nav-item @click='navigateToLiked()'>My&nbsp;Liked&nbsp;Drafts</b-nav-item>    
                    <b-nav-item v-if='this.isAuthenticated' @click='logout()'>Sign&nbsp;Out</b-nav-item>                        
                </b-nav-item-dropdown>
            </b-navbar-nav>
            <b-navbar-nav class='ml-auto'>
                <b-input-group>
                    <b-form-input size='sm' placeholder='Draft # or keyword' type="text" v-model='keyword' @keydown.native.enter='navigateToKeyword()'/>
                    <b-input-group-append>
                        <b-btn size='sm' variant='secondary' @click='navigateToKeyword()' type="button"><span class="glyphicon glyphicon-search" aria-hidden="true"/></b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
export default {
    data() {
        return {
            keyword: ''
        }
    },
    methods: {
        logout: function() {
            window.localStorage.removeItem('user')
            this.$store.commit('clearAuthUser')
            this.navigateTo('Home')
        },
        navigateTo: function(routeName) {
            // () => { location.href = this.$route.hash } works around a bug in bootstrap-vue after release 2.0.0-rc.11 where navigation to same route leaves the menu open
            this.$router.push({ name: routeName }, undefined, () => {
                location.href = this.$route.hash
            })
            return false
        },
        navigateToClipboard() {
            // () => { location.href = this.$route.hash } works around a bug in bootstrap-vue after release 2.0.0-rc.11 where navigation to same route leaves the menu open
            this.$router.push({ name: 'DraftSearch', params: { searchType: 'clipboard' }, query: { page: '0', minshafts: '0', maxshafts: '0', maxtreadles: '0', maxfloatlength: '0' } }, undefined, () => { location.href = this.$route.hash })
        },
        navigateToLiked() {
            // () => { location.href = this.$route.hash } works around a bug in bootstrap-vue after release 2.0.0-rc.11 where navigation to same route leaves the menu open
            this.$router.push({ name: 'DraftSearch', params: { searchType: 'mylikes' }, query: { page: '0', minshafts: '0', maxshafts: '0', maxtreadles: '0', maxfloatlength: '0' } }, undefined, () => { location.href = this.$route.hash })
        },
        navigateToKeyword() {
            // () => { location.href = this.$route.hash } works around a bug in bootstrap-vue after release 2.0.0-rc.11 where navigation to same route leaves the menu open
            let cleanedKeyword = this.keyword.trim()
            cleanedKeyword = cleanedKeyword.replace('#', '')
            console.log('in NavBar search, current route: ' + this.$route.name)
            if (this.$route.name !== 'DraftSearch') {
                console.log('in NavBar search, different route, keyword: ' + cleanedKeyword)
                if (cleanedKeyword.length > 0) {
                    this.$router.push({ name: 'DraftSearch', params: { searchType: 'keyword' }, query: { page: '0', minshafts: '0', maxshafts: '0', maxtreadles: '0', maxfloatlength: '0', keyword: cleanedKeyword } }, undefined, () => { location.href='/collection-drafts/keyword?page=0&minshafts=0&maxshafts=0&maxtreadles=0&maxfloatlength=0&keyword=' + cleanedKeyword })
                }
            }
            else {
                console.log('in NavBar search, same route, keyword: ' + cleanedKeyword)
                let queries = this.$route.query
                queries.keyword = cleanedKeyword
                console.log('queries: ' + JSON.stringify(queries))
                let newHrefFallback = '/collection-drafts/keyword?page=0&minshafts=0&maxshafts=0&maxtreadles=0&maxfloatlength=0&keyword=' + cleanedKeyword
                console.log('hrefFallback: ' + newHrefFallback)
                this.$router.replace({ name: 'DraftSearch', params: { searchType: 'keyword' }, query: { page: '0', minshafts: '0', maxshafts: '0', maxtreadles: '0', maxfloatlength: '0', keyword: cleanedKeyword } }).catch((err) => {
                    console.log('err: ' + err)
                    // works around a bad bug in vue router where the querystring alone cannot be changed because this throws an exception
                    location.href = newHrefFallback
                })
            }
        },
        navigateToTagCloud(searchType) {
            // () => { location.href = this.$route.hash } works around a bug in bootstrap-vue after release 2.0.0-rc.11 where navigation to same route leaves the menu open
            this.$router.push({ name: 'TagCloud', params: { searchType: searchType } }, undefined, () => { location.href = this.$route.hash })
        },
        navigateToBoards() {
            // () => { location.href = this.$route.hash } works around a bug in bootstrap-vue after release 2.0.0-rc.11 where navigation to same route leaves the menu open
            this.$router.push({ name: 'MyBoards', params: { } }, undefined, () => { location.href = this.$route.hash })
        }
    },
    computed: {
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },
        authUser: function() {
            return this.$store.state.authUser
        }
    },
    watch: {
        '$route': function() {
            this.keyword=''
        }
    }
}
</script>

<style scoped>
.nav-bar {
    background-color: #f9f8f5;
    color: #777;
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 0;
    font-size: 1em;
    border-color: #e7e7e7;
    border-bottom-width: 1px;
    border-top-style: none;
    border-right-style: none;
    border-bottom-style: solid;
    border-left-style: none;
}

.no-wrap {
    white-space: nowrap;
    overflow: hidden;
}

.logo-typeface {
    font-family: tendernessregular;
    font-size: 1.2rem;
}

</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue